<div class="maintenance-container">
  <!-- Logo Section -->
  <div class="logo-section">
    <img src="assets/icons-svg/neo-hire.svg" alt="NeoHire Logo" class="logo">
  </div>

  <!-- Main Message -->
  <div class="main-message">
    <h1 class="main-title">NeoHire will return soon</h1>
    <p class="description">
      NeoHire.ai is currently experiencing a temporary service disruption.<br>
      We're <u>working on it</u>, please check back soon.
    </p>
  </div>

  <!-- Refresh Button -->
  <button (click)="refreshScreen()" class="refresh-button" title="Refresh">
    <i class="pi pi-refresh refresh-icon"></i>
    <span class="tooltip">Refresh</span>
  </button>

  <!-- Footer -->
  <div class="footer">
    <span class="company-name">Thanks you for your patience</span>
  </div>
</div>

